import { TutorBrowsePage } from "../../components/profile/TutorBrowsePage";
import { searchTutor } from "../../store/profile/profileActions";

const TutorList = () => {
    return <TutorBrowsePage searchThunk={searchTutor} isPublic={false} />;
};

export { TutorList };
